<div class="primeiros-passos-card">
  <div class="card-header">
    <i class="pi pi-flag"></i>
    <span>{{ texts.primeiros_passos }}</span>
  </div>

  <p-progressBar [value]="progresso" [showValue]="false" styleClass="progresso-bar"></p-progressBar>

  <p-divider></p-divider>

  <div class="etapa" (click)="irParaProduto()">
    <i class="pi"
       [class.pi-check-circle]="temProduto"
       [class.pi-circle]="!temProduto"
       [class.concluido]="temProduto"></i>
    <span>{{ texts.cadastre_produto }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>

  <div class="etapa" (click)="irParaCliente()">
    <i class="pi"
       [class.pi-check-circle]="temCliente"
       [class.pi-circle]="!temCliente"
       [class.concluido]="temCliente"></i>
    <span>{{ texts.cadastre_cliente }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>

  <div class="etapa" (click)="irParaVenda()">
    <i class="pi"
       [class.pi-check-circle]="temVenda"
       [class.pi-circle]="!temVenda"
       [class.concluido]="temVenda"></i>
    <span>{{ texts.realize_venda }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>
</div>
